import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player/youtube'


function videos() {

  const tabs = [

    { title: 'School Tour', content: () => (
      <div>
        <div className="cam-lower-sec">
          <h1 className="title">School Tour</h1>
        </div>
    
        <div className="video-sec">
        <div className='video-box'>
          
<video controls width="100%" height="360px">
            <source src="/video/Sanskrvideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        </div>
        {/* <video controls width="100%" height="360px">
            <source src="/video/Sanskrvideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
    
      </div>
  )},
    { title: 'A day at Sanskar', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>A day at Sanskar</h1>
      </div>
  
      <div className='video-sec'>
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/watch?v=uU-ZeRALPdc'} />
        </div>

        </div>
        </div>
  
    },
    { title: 'Indo French Exchange', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Indo French Exchange</h1>
      </div>

      <div className='video-sec'>
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/watch?v=d1KYCS3f1XQ'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/watch?v=25xKKoM-poA'} />
        </div>
       
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/watch?v=Or4VCWY2MeA'} />
        </div>
       
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/watch?v=dMyVicAbgz4'} />
        </div>

        </div>

  
     
        </div>
  
    },
    { title: 'France India Exchange 3 Introductory (IGCSE)', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         France India Exchange-3 Introductory (IGCSE) </h1>
      </div>
  
      <div className='video-sec'>
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/ERkW0SdeI8M'}  />
        </div>
  
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/f2J0iqg_K8I'} />
        </div>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/xH4YrjlnIFg'} />
        </div>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/5Pl5n4u6roE'} />
        </div>
    
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/hRXXfJbHk48'} />
        </div>

        </div>
        </div>
  
    },
    { title: 'France India Exchange 3 Introductory', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         France India Exchange 3 Introductory</h1>
      </div>
  
      <div className='video-sec'>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://www.youtube.com/shorts/zTVTfkhRWI0'}  />
        </div>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/0iHDTd0Uv_o'}  />
        </div>
     
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/sZxKbVAdlsE'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/dj_YMBdP8aQ'}  />
        </div>
        
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/dLrJ-1aJgHA'}  />
        </div>
        
        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/ik4TJQP5JFk'}  />
        </div>


        </div>


        </div>
  
    },
    { title: 'Language Development', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Language Development</h1>
      </div>

      <div className='video-sec'>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/r2Q093agDkc'}  />
        </div>
   
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtube.com/shorts/_IR40osnCI8'}  />
        </div>
     
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/EsjC9-oJaEQ'}  />
        </div>
     
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/ig82ZedTxio'}  />
        </div>
    
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/Y4vcijwVPr4'}  />
        </div>
     
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/qe8RW5H9Au4'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/jFLaIwL8n7U'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/j2HK21Vx3hc'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/nKKjzwRPByE'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/rc9iiGxoZ7k'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/Zh_Xrhqwriw'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/YVz1to4L9O0'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/Vq4v06yNf7Q'}  />
        </div>

      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/f96-yqKfRus'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/oJhOQQj4lPU'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/kZSqdzlSqlg'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/z0ZUZWe5TAs'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/P2GGNITaZQYs'}  />
        </div>

        <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/jT91f4rhPks'}  />
        </div>

        </div>
        </div>
  
    },
    { title: 'Story telling by Grandparent', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Story telling by Grandparent</h1>
      </div>

      <div className='video-sec'>
      
      <div className='video-box'>
        <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/OOsisRjvfGM'}  />
        </div>
     
      
      </div>
  
   


      </div>
  
    },
    { title: 'Inter School Event', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Inter School Event</h1>
      </div>
  
      <div className='video-sec'>
      
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/yqgaQDSPQoM'}  />
        </div>
      
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/XCH1ZOnHbhQ'}  />
        </div>
      
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/Q1irfAeKRU8'}  />
        </div>
     
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/GfCoF3x6qYs'}  />
        </div>
     
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/lx1Nsniccaw'}  />
        </div>

        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/s5k8gbBl_C0'}  />
        </div>
        
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/hLVZIxo20zA'}  />
        </div>
      
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/M5_UVNxlqo8'}  />
        </div>
    
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/4tsDtWhpi-s'}  />
        </div>
       
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/bzRosGGRtsY'}  />
        </div>
      
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/badAd_Se9Ss'}  />
        </div>
     
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/e-Oqss5cKrI'}  />
        </div>
      
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/8pZzkf9z7Lo'}  />
        </div>
      
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/kRUGhGSKUmw'}  />
        </div>
     
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/RMb9U4i6fEk'}  />
        </div>
       
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/n7243TxrA6M'}  />
        </div>
      
        <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/hNzv_drTYG4'}  />
        </div>
      
      
      </div>  


        </div>
  
    },

  


  { title: 'Labour Day', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Labour Day </h1>
      </div>

      <div className='video-sec'>
      
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/sjZmP7DWwY0'}  />
        </div>
     
        </div>
   
        </div>
  
    },

  { title: 'Virtual Job Alike sessions (NINNS) hosted by Sanskar School, Jaipur ', content: () => <div>

      <div className='cam-lower-sec'>
         <h1 className='title'>
         Virtual Inter House English Elocution Competition 2021</h1>
      </div>

      
      <div className='video-sec'>
      
      <div className='video-box'>
       <ReactPlayer className="video-box-size" controls={true} url={'https://youtu.be/QgX6ygxTLJY'}  />
        </div>
        
      </div>

        </div>
  
    },

 
  ]
  return (
      <div>
    <div className='ibdp-hero-sec'>
       <img src='img/P25.webp'/>

     </div>
     <div className="newsletter-sec">
     <HorizontalTabs tabs={tabs} />
     </div>
     <div className='video-sec'>
        <div className='video-box'>
        {/* <ReactPlayer className="video-box-size" 
        controls={true}
        url="/video/Sanskrvideo.mp4"
        playing={false}
        width="100%"
        height="360px" /> */}

  <ReactPlayer className="video-box-size" controls={true} url='/video/Sanskrvideo.mp4' />
        </div>

        </div>

   </div> 
  )
}

export default videos;
